import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { Section, SectionTitle, CTA } from "@/components/site/SiteBits";
import { Button } from "@/components/ui/button";
import { SERVICES, img } from "@/data/services";

export default function Services() {
  return (
    <div>
      {/* Image hero */}
      <section className="relative bg-[#0B0F17] text-white overflow-hidden">
        <img src={img("ftl")} alt="Ebik freight" className="absolute inset-0 w-full h-full object-cover opacity-70" />
        <div className="absolute inset-0 hero-overlay" />
        <div className="relative max-w-7xl mx-auto px-4 lg:px-8 py-20 lg:py-28">
          <p className="eyebrow text-white/90 bg-primary/80 inline-block px-3 py-1 rounded-full">Our Services</p>
          <h1 className="mt-4 text-4xl sm:text-5xl font-heading font-extrabold tracking-tight max-w-3xl drop-shadow">
            A complete Southern African logistics portfolio
          </h1>
          <p className="mt-5 text-lg text-white max-w-2xl leading-relaxed drop-shadow">
            From full truckloads to reverse logistics — 18 core services delivered on one integrated, technology-driven platform.
          </p>
        </div>
      </section>

      <Section>
        <SectionTitle eyebrow="Capabilities" title="Every way we move your cargo"
          subtitle="Each service is backed by real-time tracking, digital documentation and our 24/7 operations control tower." />
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {SERVICES.map((s, i) => (
            <motion.div key={s.slug} initial={{ opacity: 0, y: 26 }} whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.15 }} transition={{ duration: 0.5, delay: (i % 3) * 0.06 }}>
              <div className="group rounded-2xl overflow-hidden border border-border bg-card card-hover h-full" data-testid={`service-${s.slug}`}>
                <div className="relative h-44 overflow-hidden">
                  <img src={img(s.slug)} alt={s.title} className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700" />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent" />
                  <div className="absolute top-3 left-3 w-10 h-10 rounded-lg bg-primary flex items-center justify-center shadow-lg">
                    <s.icon size={20} className="text-white" />
                  </div>
                </div>
                <div className="p-5">
                  <h3 className="font-heading font-bold text-lg">{s.title}</h3>
                  <p className="mt-2 text-sm text-muted-foreground leading-relaxed">{s.desc}</p>
                  <Link to="/quote" className="mt-3 inline-flex items-center gap-1 text-sm font-semibold text-primary">
                    Get a quote <ArrowRight size={14} />
                  </Link>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </Section>
      <CTA />
    </div>
  );
}
